export const LOGIN_LABELS = {
  signIn: 'INICIAR SESIÓN',
  signingIn: 'INICIANDO SESIÓN...',
  signInB2C: 'INICIAR SESIÓN B2C',
  username: 'Usuario',
  password: 'Contraseña',
  usernameRequired: 'Usuario requerido',
  emailInvalid: 'Debe ser un correo',
  passwordRequired: 'Contraseña requerida',
  passwordMinLength: 'Mínimo 6 caracteres',
  logoWapi: 'Logo WAPI',
  logoAlc: 'Logo Alc'
};
